export default __webpack_public_path__ + "static/media/111.c03e931a.jpg";